// A short, bounded history of actual analyser extrema. New audio enters on the
// right; the SVG moves one sample pair left between the 80 ms meter updates.
export default function VoiceWaveform({ waveform, level, paused, label }) {
  const values = waveform?.samples || [];
  const samples = [...Array(Math.max(0, 64 - values.length)).fill(0), ...values];
  const y = (value) => 18 - value * 15;
  let path = `M -12 ${y(samples[0])}`;
  for (let i = 1; i < samples.length; i += 1) {
    const x = i * 4 - 12;
    path += ` C ${x - 2} ${y(samples[i - 1])} ${x - 2} ${y(samples[i])} ${x} ${y(samples[i])}`;
  }
  return <div className="pc-voice-wave" role="meter" aria-label={label}
    aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round((level || 0) * 100)}
    data-testid="voice-wave" data-paused={paused || undefined}>
    <svg viewBox="0 0 240 36" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <g key={waveform?.frame || 0} className="pc-voice-wave__flow">
        <path d={path} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
      </g>
    </svg>
  </div>;
}
